<template>
  <div>
    <div :style="{height:mHeaderHeight}"></div>
    <div ref="mallHeader" class="mall-header">
      <div class="menu-area" v-if="!$route.query.soga_card">
        <Icon type="md-menu" size="32" color="white"
              @click.stop="onOpenDrawer"></Icon>
        <!-- 左菜单 -->
        <Drawer v-model="menu_drawer" placement="left"
                class-name="header-menu-drawer"
                :width="menu_width" :closable="false">
          <div slot="header" style="display: table;width: 100%;">
            <img @click.stop="onLogoClick"
                 src="@/assets/logo-red.png" width="141" height="32"
                 class="drawer-logo" style="display: table-cell;cursor: pointer;">
            <span style="display: table-cell;" class="drawer-close">
              <icon @click.stop="menu_drawer=false" type="md-close" size="32"></icon>
            </span>
          </div>
          <!-- 商品分类 -->
          <Menu v-if="mGroups.length>0" :open-names="['1']"
                class="group-menu" style="width: 100%;"
                @on-select="menu_drawer=false">
            <MenuGroup :title="$t('goods.group')" name="0" style="line-height: 100%">
              <!--
              <MenuItem name="0" to="/"
                        class="level1-menu">{{$t('goods.group_all')}}</MenuItem>
              -->
              <Submenu v-for="(sm, smi) in mGroups" :key="smi" :name="''+(smi+1)">
                <span slot="title" @click.stop="goGoodsGroup(sm.id,sm.name)">{{sm.name}}</span>
                <MenuItem v-for="(mi,i) in sm.children" :key="i"
                          :to="{name:'GoodsGroup',query:{id:mi.id,group:sm.name+'/'+mi.name}}"
                          :name="(smi+1)+'-'+(i+1)">{{mi.name}}</MenuItem>
              </Submenu>
            </MenuGroup>
          </Menu>
          <!-- 固定底部 -->
          <div class="menu-footer">
            <Menu style="width: 100%;"
                  @on-select="menu_drawer = false">
              <MenuGroup :title="$t('menu.group_title_note')" style="line-height: 100%">
                <MenuItem to="about" name="1-1"
                          class="level1-menu">{{$t('menu.item_label_about')}}</MenuItem>
                <MenuItem to="notice" name="1-2"
                          class="level1-menu">{{$t('menu.item_label_notice')}}</MenuItem>
                <MenuItem to="qa" name="1-3"
                          class="level1-menu">{{$t('menu.item_label_qa')}}</MenuItem>
                <MenuItem to="privacy" name="1-4"
                          class="level1-menu">{{$t('menu.item_label_privacy')}}</MenuItem>
              </MenuGroup>
            </Menu>
            <div class="menu-footer-info">
              <p v-html="$t('footer_info_html')" class="footer-info"></p>
              <p class="footer-icon-group">
                <img src="@/assets/website.png" alt="" @click.stop="$router.face.gotoOfficial()">
                <img src="@/assets/youtube.png" alt="" @click.stop="go('https://reurl.cc/gzvQmp')">
                <img src="@/assets/facebook.png" alt="" @click.stop="go('https://www.facebook.com/tvsoga')">
                <img src="@/assets/line.png" alt="" @click.stop="go('https://lin.ee/ab3KmCi')">
              </p>
            </div>
          </div>
        </Drawer>
      </div>
      <!-- logo -->
      <div class="logo-area">
        <img class="logo-area3" src="@/assets/logo-white.png" alt=""
             @click.stop="$router.push('/')"/>
      </div>
      <!-- 会员区域 -->
      <div class="member-area" v-if="!$route.query.soga_card">
        <Icon v-if="!!$route.meta.isLogin && !$store.state.userinfo"
              type="md-person" size="32" color="white"/>
        <Dropdown v-else @on-click="onMemberMenu"
                  :class="horizontal?'':'menu-panel'"
                  placement="bottom-end" trigger="click">
          <a href="javascript:void(0)">
            <Avatar v-if="$store.state.userinfo"
                    :src="$store.getters.userHead"
                    @on-error="$store.commit('clearHead')"></Avatar>
            <Icon v-else type="md-person" size="32" color="white"></Icon>
          </a>
          <DropdownMenu v-if="$store.state.userinfo" slot="list" class="member-menu">
            <DropdownItem name="orders">{{$t('menu.order_query')}}</DropdownItem>
            <DropdownItem name="member">{{$t('menu.member_area')}}</DropdownItem>
            <DropdownItem name="addresses">{{$t('menu.member_addr')}}</DropdownItem>
            <DropdownItem name="logout" v-if="!$store.getters.inSoga">{{$t('menu.logout')}}</DropdownItem>
            <DropdownItem name="account/delete">{{$t('menu.delete_account')}}</DropdownItem>
          </DropdownMenu>
          <DropdownMenu v-else slot="list" class="member-menu">
            <DropdownItem name="login">{{$t('menu.register_login')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  </div>
</template>

<script>
    import { httpGet } from '@/api/http';

    export default {
        name: 'Header',
        data () {
            return {
                horizontal: true,
                menu_drawer: false,
                menu_width: -1,

                loading: true,
                mGroups: [],
                // 数据加载时间
                loadedTime: 0,
                mHeaderHeight: '30px'
            }
        },
        methods: {
            go (url) {
                window.location.href = url;
            },
            onOpenDrawer () {
                if (this.loadedTime + 5 * 60 * 1000 < new Date().getTime()) {
                    this.loadData();
                }
                this.menu_drawer = true;
            },
            onLogoClick () {
                this.$router.push('/');
                this.menu_drawer = false
            },
            onMemberMenu (name) {
                if (name === 'logout') {
                    if (this.$router.face.logout()) {
                        this.$Message.info(this.$t('menu.tip_logout'));
                    }
                } else if (name === 'login') {
                    this.$router.face.login();
                } else {
                    this.$router.push(name);
                }
            },

            loadData () {
                this.loading = true;
                httpGet('/v1/goods/classes', null, { ignores: [] }).then(res => {
                    if (this.mGroups.length > 0) {
                        this.mGroups.splice(0);
                    }
                    for (const i in res) {
                        if (res[i].children.length > 0) {
                            this.mGroups.push(res[i]);
                        }
                    }
                    this.loadedTime = new Date().getTime();
                }).catch(() => {
                }).finally(() => {
                    this.loading = false;
                });
            },
            setHeaderPad: function () {
                this.$nextTick(() => {
                    if (this.$refs.mallHeader !== undefined) {
                        this.mHeaderHeight = this.$refs.mallHeader.clientHeight + 'px'
                    }
                })
            },
            goGoodsGroup: function (id, group) {
                this.menu_drawer = false
                this.$router.push({ path: '/goods', name: 'GoodsGroup', query: { id: id, group: group } })
            }
        },
        mounted () {
            this.setHeaderPad()
            window.onresize = () => {
                this.setHeaderPad()
            }
        },
        created () {
            if (window.screen.width < 730) {
                this.menu_width = 90;
            } else {
                this.menu_width = 30;
            }
            this.horizontal = window.screen.width > window.screen.height;
            this.loadData();
        }
    }
</script>

<style lang="scss">
  .mall-header {
    position: fixed;
    z-index: 10;
    top:0;
    left:0;
    padding: 14px;
    display: flex;
    align-items: center;
    //justify-content: space-between;
    align-content: center;
    justify-content: center;
    width: 100%;
    height: 14vw;
    max-height:60px ;
    background-color: #ee3f38;

    .menu-area {
      text-align: left;
      &>i {
        cursor: pointer;
      }
    }

    .logo-area {
      height: 32px;
      flex-grow: 1;
      display: flex;
      justify-content: center;

      & > img {
        height: 100%;
        width: auto;
        cursor: pointer;
      }
    }

    .member-area {
      text-align: right;
      .menu-panel {
        width: 100%;
      }
      .member-menu {
        text-align: left;
      }
      .ivu-select-dropdown {
        border-radius: 0;
        margin-top: 10px;
        margin-left: -5px;
        background-color: #efefef;
        font-weight: bold;
      }
    }
  }
  .header-menu-drawer {
    .level1-menu {
      font-weight: bold;
    }

    .ivu-drawer-body {
      padding: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      .ivu-menu-item-group-title {
        padding-left: 16px;
        padding-right: 5px;

        font-size: larger;
        font-weight: bold;
        color: #707070;
        background-color: #efefef;
        //border: solid 1px #707070;
        border-left: none;
        border-right: none;
      }
      .ivu-menu-item {
        // t, r, b, l
        padding: 8px 5px 8px 20px;
      }
      .ivu-menu-submenu-title {
        // t, r, b, l
        padding: 10px 5px 10px 20px;

        font-weight: bold;
      }
      .group-menu {
        flex-grow: 1;
      }

      .menu-footer {
        height: 376px;
      }
      .menu-footer-info {
        background-color: #efefef;
        padding: 16px;
        //border-top: solid 1px dimgrey;
      }
      .share-custom-btn {
        padding: 1px;
        font-size: 8pt;
        min-width: 24px;
      }
      .footer-info {
        font-size: smaller;
        font-weight: bold;
      }
      .footer-icon-group{
        padding: 15px 0;
        display: flex;
        justify-content: space-between;
        width: 44vw;
        max-width: 176px;
        &>img{
          width: 8vw;
          max-width: 32px;
          height: 8vw;
          max-height: 32px;
          cursor: pointer;
        }
      }
    }
    .drawer-logo {
      vertical-align: top;
    }
    .drawer-close {
      text-align: right;
      vertical-align: top;
      cursor: pointer;
    }
  }
</style>
